function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail24 = function SvgMail24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 7.5v-1c0-1.1-.9-2-2-2H4.2c-1.1 0-2 .9-2 2v10.8c0 1.1.9 2 2 2H20c1.1 0 2-.9 2-2V7.5zm-.9 10.3-5.8-5.7 5.9-3.9v9.1c0 .2 0 .4-.1.5zM4.2 5.2H20c.7 0 1.2.6 1.2 1.2v.8l-8 5.3c-.6.4-1.7.4-2.3 0L3 7.3v-.9c0-.6.5-1.2 1.2-1.2zM3.1 17.8c-.1-.1-.1-.3-.1-.5V8.2l5.9 3.9-5.8 5.7zm1.1.7c-.2 0-.4 0-.6-.1l5.9-5.9 1 .7c.4.3 1 .4 1.6.4.6 0 1.1-.1 1.6-.4l1-.7 5.9 5.9c-.2.1-.4.1-.6.1H4.2z",
    style: {
      fill: "#393839"
    }
  }));
};
export default SvgMail24;